class WhatWeBelieveSlider {
    #section;
    #swiper = null;

    constructor(section) {
        this.#section = section;
        this.#init();
    }

    #init() {
        if (typeof window.Swiper === 'undefined' || this.#swiper) return;

        const sliderEl = this.#section.querySelector('.humble-what-we-believe__cards');
        if (!sliderEl) return;

        this.#swiper = new window.Swiper(sliderEl, {
            // Base (< 990px): cards 199px fijas, offsets laterales
            slidesPerView: 'auto',
            spaceBetween: 16,
            slidesOffsetBefore: 24,
            slidesOffsetAfter: 24,
            // Swiper locks itself when every slide fits without overflowing
            watchOverflow: true,
            grabCursor: true,
            keyboard: { enabled: true },
            a11y: { enabled: true },
            observer: true,
            observeParents: true,
            resizeObserver: true,
            breakpoints: {
                // 990–1439px: 199px cards, no offsets (the inner has padding-inline: 40px)
                990: {
                    slidesPerView: 'auto',
                    spaceBetween: 24,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
                // >= 1440px: 4 cards fill the available width.
                // With watchOverflow: exactly 4 -> Swiper locks (no swipe).
                // 5+ -> Swiper stays active and allows scrolling.
                1440: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                },
            },
        });
    }
}

const init = () => {
    document.querySelectorAll('.humble-what-we-believe').forEach(
          (el) => new WhatWeBelieveSlider(el)
        );
};

if (['interactive', 'complete'].includes(document.readyState)) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init, { once: true });
}
